import * as React from "react";
import DataImage from "../../DataImage";
import {IFoodBanksProps} from "../../utils/models";
import makeSum from "../../../../utils/makeSum";
import image from '../../asset/5. Food in.png'

const TotalFoodIn = ({ submissions }: IFoodBanksProps) => {
    return (
        <DataImage
            image={image}
            value={`Kg ${makeSum(submissions, 'total_food_in_kg')}`}
            text="Total Food IN"
        />
    );
}

export default TotalFoodIn;